module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "300px"
    },
    attrs: {
      "id": _vm.id
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dd4e9514"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/charts/pie.vue
// module id = 1443
// module chunks = 1